import React from 'react';
import Heatmap from './view/heatmap/Heatmap';
import './App.css';
import ScatterPlotView from './view/scatterplot/ScatterPlotView';
import USMap from "./view/geographic/USMap";
import { DashboardProvider } from "./model/DashboardContext";
import { Container, Grid, Stack } from '@mui/material';
import EthnicitySelector from "./view/scatterplot/EthnicitySelector";

const App: React.FC = () => {
    // Common style for drop shadow
    const dropShadowStyle = {
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)', // Drop shadow effect
        borderRadius: '10px', // Rounded corners
        padding: '10px', // Padding around the content for the shadow
        backgroundColor: 'white', // Background for visibility
        width: 'fit-content', // Ensures the box fits the content (important for dynamic sizes)
        height: 'fit-content', // Ensures the box fits the content (important for dynamic sizes)
        paddingLeft: 0
    };

    return (
        <DashboardProvider>
            <Container sx={{ bottom: 0, transform: 'scale(0.95)', width: '100%', ml: 0, mr: 0 }}>
            <h1 style = {{'display' : 'flex', 'fontSize': 19, 'fontWeight': 1000, marginTop: '-18px'}}>Voter Demographic and Electoral College Impact on the US Election</h1>
                <Grid container spacing={2} marginTop={-1.75}>
                    <Grid item xs={6}>
                        <div style={dropShadowStyle}>
                        <Grid container spacing={2}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div style={{width:560, flex: 1, marginLeft:20 }}>
                                <Heatmap  />
                            </div>
                            </div>
                    </Grid>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingLeft: 30, paddingTop: 0, ml: 0}}>
                        <Stack spacing={2}>
                            <div style={dropShadowStyle}>
                                <div style={{width:800, flex: 1, marginLeft:30 ,  display: 'flex',}} >{/*style={mapContainerStyle}>*/}
                                    <USMap xScale={0.9} yScale={0.9} />
                                </div>
                            </div>
                            <div style={dropShadowStyle}>
                                <div style={{ marginLeft: '30px' }}>
                                    <EthnicitySelector/>
                                </div>
                                <div style={{width:800, flex: 1, marginLeft:30, display: 'flex', flexDirection: 'row' }}>
                                <ScatterPlotView xScale={1} yScale={1}/>
                                </div>
                            </div>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </DashboardProvider>
    );
};


export default App;